import * as React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import DeletionRequestPage from './DeletionRequestPage';

interface RouteParams { 
  id: string; 
  url: string 
};

function DeletionRequest({ match }: RouteComponentProps<RouteParams>) {
  return (
    <Switch>
      <Route path={`${match.url}/`} component={DeletionRequestPage} />
    </Switch>
  );
}

export default DeletionRequest;
